export const getFileExtension = (file) => {
  if (!file) {
    return null
  }
  const re = /(?:\.([^.]+))?$/
  return re.exec(file)[1]
}
